import React from "react";
import { Typography } from "@mui/material";
import StyledCard from "./styles";

const CardHome = ({ title, description, image, link }) => {
  const onClickHandler = () => {
    if (link && window) {
      window.open(`${link}`, "_blank");
    }
  };
  return (
    <StyledCard onClick={onClickHandler}>
      <div className="home-card">
        <div className="home-card-img">
          <img src={image} alt={`${title}-img`} />
        </div>
        <div className="card-home-text">
          {title && (
            <Typography
              variant="h6"
              fontWeight={600}
              fontSize={20}
              lineHeight={1.3}
            >
              {title}
            </Typography>
          )}
          {description && (
            <Typography variant="body1">{description}</Typography>
          )}
        </div>
      </div>
    </StyledCard>
  );
};

export default CardHome;
